<h2 class="mt-3 mb-4">Account Details</h2>
<div class="notice notice-error" *ngIf="error">
  <div class="notice-body">
    Failed to update account details<br>{{ error?.description }}
  </div>
</div>
<div class="notice" *ngIf="showMessage">
  <div class="notice-body">
    Successfully updated details
  </div>
</div>

<form [formGroup]="AccountDetailsForm" class="material-form-grid">
  <mat-form-field appearance="fill">
    <mat-label>Username</mat-label>
    <input matInput id="userName" formControlName="userName" />
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Email</mat-label>
    <input matInput id="email" type="email" formControlName="email" />
  </mat-form-field>

  <div class="full-width">
    <mat-checkbox id="emailUpdates" formControlName="emailUpdates">Email me when new releases are
      available</mat-checkbox>
  </div>

  <mat-form-field appearance="fill" class="full-width">
    <mat-label>Address 1</mat-label>
    <input matInput id="address1" formControlName="address1" />
  </mat-form-field>

  <mat-form-field appearance="fill" class="full-width">
    <mat-label>Address 2</mat-label>
    <input matInput id="address2" formControlName="address2" />
  </mat-form-field>

  <mat-form-field appearance="fill" class="full-width">
    <mat-label>Address 3</mat-label>
    <input matInput id="address3" formControlName="address3" />
  </mat-form-field>

  <mat-form-field appearance="fill" class="full-width">
    <mat-label>Address 4</mat-label>
    <input matInput id="address4" formControlName="address4" />
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>City</mat-label>
    <input matInput id="city" formControlName="city" />
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Zip/Postcode</mat-label>
    <input matInput id="postCode" formControlName="postCode" />
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>State/County</mat-label>
    <input matInput id="state" formControlName="state" />
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Country</mat-label>
    <mat-select id="country" formControlName="country">
      <mat-option *ngFor="let country of countries" [value]="country.nativeName">{{ country.nativeName }}</mat-option>
    </mat-select>
  </mat-form-field>

  <app-all-seeing-eye formControlName="password" hintText="Required for authorisation"></app-all-seeing-eye>



  <div class="form-actions full-width">
    <button mat-flat-button color="primary" id="account-details-save-button" type="button" (click)="updateUser()"
      [disabled]="saveDisabled()">
      <mat-spinner *ngIf="saving" diameter="20" mode="indeterminate"></mat-spinner>
      {{ saving ? 'Saving' : 'Save' }}
    </button>
  </div>
</form>
